import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const policyListVerifiedSlice = createApi({
    reducerPath: "policyListVerified",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://pbp.policy-parser.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        policyListVerified: builder.query({
            query: (data) => ({ url: "/api/v1/pdf/list", params: data, method: "GET" }),
        }),
    }),
});

export const { usePolicyListVerifiedQuery } = policyListVerifiedSlice;
